import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { imagesBasePath } from '../../../../play-core/utils/base-path';
import { randomInRange } from '../../../../play-core/utils/random';
import { usePlayConfig } from '../../config/PlayConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const randomGif = businessUnit => businessUnit === 'rsi' ? `${imagesBasePath}/404/${businessUnit}/${randomInRange(1, 3)}.gif` : `${imagesBasePath}/404/${randomInRange(1, 7)}.gif?5205-2`;
export const ErrorGif = ({
  gif
}) => {
  const {
    t
  } = useTranslation();
  const {
    businessUnit
  } = usePlayConfig();
  // initial state is the gif passed as prop to match the server response
  const [gifSource, setGifSource] = useState(gif ?? randomGif(businessUnit));
  useEffect(() => {
    // change the gif every 5 seconds in the client
    const intervalId = window.setInterval(() => setGifSource(randomGif(businessUnit)), 5000);
    return () => {
      window.clearInterval(intervalId);
    };
  });
  return /*#__PURE__*/_jsx(AnimatedGifContainer, {
    children: /*#__PURE__*/_jsx(AnimatedGif, {
      src: gifSource,
      alt: t('pageNotFound.title')
    })
  });
};
const AnimatedGifContainer = styled.div.withConfig({
  displayName: "ErrorGif__AnimatedGifContainer",
  componentId: "sc-1jrynf-0"
})(["margin-top:120px;display:flex;justify-content:center;width:100%;", "{margin-top:60px;}"], Viewports.for('small'));
const AnimatedGif = styled.img.withConfig({
  displayName: "ErrorGif__AnimatedGif",
  componentId: "sc-1jrynf-1"
})(["height:225px;width:auto;display:block;"]);